(function () {
  function variantOptions(v) {
    if (Array.isArray(v.options) && v.options.length) return v.options;
    const o = [];
    if (v.option1 != null && v.option1 !== '') o.push(v.option1);
    if (v.option2 != null && v.option2 !== '') o.push(v.option2);
    if (v.option3 != null && v.option3 !== '') o.push(v.option3);
    return o;
  }

  function toCm(value, unit) {
    const n = parseFloat(value);
    if (Number.isNaN(n) || n <= 0) return null;
    if (unit === 'mm') return n / 10;
    if (unit === 'in') return n * 2.54;
    return n;
  }

  function getDawnPicker(sectionId) {
    return (
      document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
      document.querySelector(`variant-selects[data-section="${sectionId}"]`)
    );
  }

  function getWokieeSwatchRoot() {
    const el = document.querySelector('.tt-product-single-info .tt-swatches-container-js');
    return el && el.querySelector('ul.tt-options-swatch') ? el : null;
  }

  function getCurrentOptionsDawn(picker) {
    if (picker.tagName === 'VARIANT-RADIOS') {
      return Array.from(picker.querySelectorAll('fieldset')).map((fs) => {
        const c = fs.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      });
    }
    return Array.from(picker.querySelectorAll('select')).map((s) => s.value);
  }

  function getCurrentOptionsWokiee(swatchRoot) {
    const uls = swatchRoot.querySelectorAll('ul.tt-options-swatch');
    const opts = [];
    uls.forEach((ul) => {
      const active = ul.querySelector('li.active a');
      if (!active) {
        opts.push(null);
        return;
      }
      const dv = active.getAttribute('data-value');
      opts.push(dv != null && dv !== '' ? dv : active.textContent.trim());
    });
    return opts;
  }

  function setOptionValue(picker, optionIndex, value) {
    if (picker.tagName === 'VARIANT-RADIOS') {
      const fieldsets = picker.querySelectorAll('fieldset');
      const fs = fieldsets[optionIndex];
      if (!fs) return false;
      const esc =
        typeof CSS !== 'undefined' && CSS.escape
          ? CSS.escape(value)
          : value.replace(/"/g, '\\"');
      let input = fs.querySelector(`input[type="radio"][value="${esc}"]`);
      if (!input) {
        input = Array.from(fs.querySelectorAll('input[type="radio"]')).find(
          (el) => el.value === value
        );
      }
      if (!input || input.disabled || input.classList.contains('disabled')) return false;
      input.checked = true;
      return true;
    }
    const selects = picker.querySelectorAll('select');
    const sel = selects[optionIndex];
    if (!sel) return false;
    const opt = Array.from(sel.options).find((o) => o.value === value);
    if (!opt || opt.disabled) return false;
    sel.value = value;
    return true;
  }

  function applyVariantDawn(picker, variant) {
    const opts = variantOptions(variant);
    for (let i = 0; i < opts.length; i++) {
      if (!setOptionValue(picker, i, opts[i])) {
        return false;
      }
    }
    const isRadios = picker.tagName.toLowerCase() === 'variant-radios';
    if (isRadios) {
      const fieldsets = picker.querySelectorAll('fieldset');
      const lastChecked = fieldsets[fieldsets.length - 1]?.querySelector('input[type="radio"]:checked');
      if (lastChecked) lastChecked.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const selects = picker.querySelectorAll('select');
      const sel = selects[selects.length - 1];
      if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function applyVariantWokiee(swatchRoot, variant) {
    const vo = variantOptions(variant);

    for (let i = 0; i < vo.length; i++) {
      const uls = swatchRoot.querySelectorAll('ul.tt-options-swatch');
      const ul = uls[i];
      if (!ul) return false;
      const want = vo[i];
      const links = ul.querySelectorAll('li a');
      let target = null;
      for (let j = 0; j < links.length; j++) {
        const a = links[j];
        const li = a.closest('li');
        if (li && (li.classList.contains('unavailable') || a.classList.contains('disable'))) continue;
        const dv = a.getAttribute('data-value');
        const txt = a.textContent.trim();
        if (dv === want || txt === want) {
          target = a;
          break;
        }
      }
      if (!target) return false;
      const li = target.closest('li');
      if (!li || li.classList.contains('active')) continue;
      target.click();
    }

    const idInput =
      document.querySelector('.tt-product-single-info input.input_variant[name="id"]') ||
      document.querySelector('.tt-product-single-info form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      idInput.value = String(variant.id);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function updatePricesFromVariant(variant, root) {
    if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') return;
    var mf = typeof money_format !== 'undefined' ? money_format : '{{amount}}';
    var cents = Number(variant.price);
    var compare = variant.compare_at_price != null ? Number(variant.compare_at_price) : 0;
    var hasSale = compare > cents;

    function applyToPriceBox(box) {
      if (!box) return;
      var main = box.querySelector('span.sale-price, span.new-price') || box.querySelector('span:first-child');
      var oldEl = box.querySelector('.old-price');
      if (!main) return;
      main.innerHTML = Shopify.formatMoney(cents, mf);
      if (hasSale) {
        main.classList.remove('new-price');
        main.classList.add('sale-price');
        if (oldEl) {
          oldEl.innerHTML = Shopify.formatMoney(compare, mf);
          oldEl.classList.remove('hide');
        }
      } else {
        main.classList.remove('sale-price');
        main.classList.add('new-price');
        if (oldEl) {
          oldEl.innerHTML = '';
          oldEl.classList.add('hide');
        }
      }
    }

    var info = document.querySelector('.tt-product-single-info');
    if (info) applyToPriceBox(info.querySelector('.tt-price'));
    if (root) applyToPriceBox(root.querySelector('[data-mp-price-display]'));

    if (typeof jQuery !== 'undefined') jQuery('body').trigger('refreshCurrency');
  }

  function findVariantByMetafieldsCeiling(
    measurementRows,
    variants,
    wCm,
    dCm,
    sizeOptionIndex,
    currentOptions
  ) {
    const byId = {};
    measurementRows.forEach((m) => {
      byId[m.id] = m;
    });

    const eps = 1e-6;

    const covering = [];
    for (let vi = 0; vi < variants.length; vi++) {
      const v = variants[vi];
      const m = byId[v.id];
      if (!m || m.widthCm == null || m.dropCm == null) continue;
      const cw = Number(m.widthCm);
      const cd = Number(m.dropCm);
      if (!Number.isFinite(cw) || !Number.isFinite(cd)) continue;
      if (cw + eps < wCm || cd + eps < dCm) continue;

      const vo = variantOptions(v);
      let ok = true;
      for (let i = 0; i < vo.length; i++) {
        if (i === sizeOptionIndex) continue;
        if (currentOptions[i] != null && vo[i] !== currentOptions[i]) {
          ok = false;
          break;
        }
      }
      if (!ok) continue;
      covering.push(v);
    }

    if (!covering.length) return null;

    covering.sort((a, b) => {
      const ma = byId[a.id];
      const mb = byId[b.id];
      const wa = Number(ma.widthCm);
      const wb = Number(mb.widthCm);
      if (wa !== wb) return wa - wb;
      const da = Number(ma.dropCm);
      const db = Number(mb.dropCm);
      if (da !== db) return da - db;
      return 0;
    });

    const avail = covering.find((v) => v.available);
    return avail || covering[0];
  }

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const formId = root.dataset.formId;
    const tierOptionName = root.dataset.tierOptionName || 'Size';

    let variantMeasurements;
    try {
      variantMeasurements = JSON.parse(
        root.querySelector('[data-variant-measurements-json]')?.textContent || '[]'
      );
    } catch (e) {
      variantMeasurements = [];
    }

    let wokieeProduct = null;
    try {
      const wj = root.querySelector('[data-wokiee-product-json]')?.textContent;
      if (wj) wokieeProduct = JSON.parse(wj);
    } catch (e) {
      wokieeProduct = null;
    }

    const optionNames = JSON.parse(root.querySelector('[data-option-names-json]')?.textContent || '[]');
    const tierKey = (tierOptionName || 'Size').trim().toLowerCase();
    const tierOptionIndex = optionNames.findIndex((n) => (n || '').trim().toLowerCase() === tierKey);
    if (tierOptionIndex < 0) {
      root.querySelector('[data-mp-message]').textContent =
        'Pricing isn’t available on this product right now. Please refresh the page or contact the store for help.';
      root.querySelector('[data-mp-message]').classList.add('measurement-pricing__message--error');
      return;
    }

    const widthInput = root.querySelector('[data-width]');
    const dropInput = root.querySelector('[data-drop]');
    const msgEl = root.querySelector('[data-mp-message]');
    const form = document.getElementById(formId);
    const minWidthCmRaw = Number(root.dataset.minWidthCm || 0);
    const minDropCmRaw = Number(root.dataset.minDropCm || 0);
    const minWidthCm = Number.isFinite(minWidthCmRaw) && minWidthCmRaw > 0 ? minWidthCmRaw : 0;
    const minDropCm = Number.isFinite(minDropCmRaw) && minDropCmRaw > 0 ? minDropCmRaw : 0;
    const fitPropertyName = (root.dataset.mpFitPropertyName || 'Fit type').trim() || 'Fit type';

    function setProps(w, d, unit, summaryLabel, fitChoiceLabel) {
      if (!form) return;
      const set = (name, val) => {
        let el = form.querySelector(`input[name="properties[${name}]"]`);
        if (!el) {
          el = document.createElement('input');
          el.type = 'hidden';
          el.name = `properties[${name}]`;
          el.setAttribute('form', formId);
          form.appendChild(el);
        }
        el.value = val;
      };
      set('Width', String(w));
      set('Drop', String(d));
      set('Unit', unit);
      set('Catalog size', summaryLabel);
      if (fitChoiceLabel) set(fitPropertyName, String(fitChoiceLabel));
    }

    root.querySelector('[data-get-price]')?.addEventListener('click', function () {
      msgEl.textContent = '';
      msgEl.className = 'measurement-pricing__message';

      const unit = root.querySelector('input[name="mp-unit-' + sectionId + '"]:checked')?.value || 'cm';
      const wCm = toCm(widthInput.value, unit);
      const dCm = toCm(dropInput.value, unit);

      if (wCm == null || dCm == null) {
        msgEl.textContent = 'Please enter a width and drop using numbers greater than zero.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }
      
      if (wCm + 1e-6 < minWidthCm || dCm + 1e-6 < minDropCm) {
        const parts = [];
        if (minWidthCm > 0) parts.push('width ' + minWidthCm + ' cm');
        if (minDropCm > 0) parts.push('drop ' + minDropCm + ' cm');
        msgEl.textContent =
          'Please enter at least ' +
          parts.join(' and ') +
          ' for this product, then tap Get an instant price.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }


      const dawnPicker = getDawnPicker(sectionId);
      const wokieeRoot = !dawnPicker ? getWokieeSwatchRoot() : null;

      if (!dawnPicker && !wokieeRoot) {
        msgEl.textContent =
          'Options are still loading or this product isn’t ready yet. Wait a moment, refresh the page, and try again.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      let variants;
      let options;
      let applyVariant;

      if (dawnPicker) {
        try {
          variants = JSON.parse(dawnPicker.querySelector('script[type="application/json"]').textContent);
        } catch (e) {
          variants = [];
        }
        options = getCurrentOptionsDawn(dawnPicker);
        applyVariant = function (v) {
          return applyVariantDawn(dawnPicker, v);
        };
      } else {
        variants = (wokieeProduct && wokieeProduct.variants) || [];
        options = getCurrentOptionsWokiee(wokieeRoot);
        applyVariant = function (v) {
          return applyVariantWokiee(wokieeRoot, v);
        };
      }

      if (!options.length || !options.every(Boolean)) {
        msgEl.textContent =
          'Please choose every option above first, then tap Get an instant price again.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      const wDisplay = widthInput.value.trim();
      const dDisplay = dropInput.value.trim();

      if (!variantMeasurements.length) {
        msgEl.textContent =
          'Instant pricing isn’t available for this product yet. Please contact the store for a quote.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      const variantForMeta = findVariantByMetafieldsCeiling(
        variantMeasurements,
        variants,
        wCm,
        dCm,
        tierOptionIndex,
        options
      );

      if (!variantForMeta) {
        msgEl.textContent =
          'These dimensions (' +
          wCm.toFixed(1) +
          ' × ' +
          dCm.toFixed(1) +
          ' cm) are larger than our standard sizes online. Try lower dimensions, or contact support — we can often help with custom sizes.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      if (!variantForMeta.available) {
        msgEl.textContent =
          'That size is out of stock right now. Try different measurements or check back later.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      const applied = applyVariant(variantForMeta);
      if (!applied) {
        msgEl.textContent =
          'That option isn’t available at the moment. Try other measurements or contact the store.';
        msgEl.classList.add('measurement-pricing__message--error');
        return;
      }

      const vo = variantOptions(variantForMeta);
      const summary = vo.join(' / ');
      const fitRadio = root.querySelector(
        'input[name="mp-fit-' + sectionId + '"]:checked'
      );
      const fitChoice =
        (fitRadio && fitRadio.getAttribute('data-mp-fit-label')) || '';

      setProps(wDisplay, dDisplay, unit, summary, fitChoice);

      updatePricesFromVariant(variantForMeta, root);

      msgEl.textContent = '';
      msgEl.className = 'measurement-pricing__message';
    });
  }

  document.querySelectorAll('measurement-pricing').forEach(init);
})();
